import clsx from 'clsx';
import { forwardRef, type InputHTMLAttributes } from 'react';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { invalid, className, ...rest },
  ref,
) {
  return (
    <input
      ref={ref}
      {...rest}
      aria-invalid={invalid || undefined}
      className={clsx(
        'block w-full rounded-[var(--radius-md)] border bg-bg-base px-3 py-2 text-sm text-text-primary',
        'placeholder:text-text-muted transition-[box-shadow,border-color] duration-[var(--duration-fast)]',
        invalid ? 'border-danger' : 'border-border-subtle',
        className,
      )}
    />
  );
});
